<template>
  <section>
    <SCompanyCardSkeleton has-show-more logo-emphasized />
    <CompanyWallDetailsPortfolioSkeleton />
  </section>
  <section>
    <SHeading level="2" size="2">
      {{ tr("main_site.company_wall.products_title") }}
    </SHeading>
    <CompanyWallProductsSkeleton />
  </section>
  <section>
    <SHeading level="2" size="2">
      {{ tr("main_site.company_wall.characteristics_title") }}
    </SHeading>
    <CompanyWallDetailsCharacteristicsSkeleton />
  </section>
  <section>
    <SHeading level="2" size="2">
      {{ tr("main_site.company_wall.faq_title") }}
    </SHeading>
    <CompanyWallQuestionsSkeleton />
  </section>
  <section>
    <SHeading level="2" size="2">
      {{ tr("main_site.company_wall.locations_title") }}
    </SHeading>
    <IconInfoCardSkeleton description-width="250px" title-width="110px" />
  </section>
</template>

<script setup lang="ts">
import { SCompanyCardSkeleton, SHeading } from "@solvari/components";
import { useI18nMainSiteCompanyWall } from "@solvari/translations";

import CompanyWallDetailsCharacteristicsSkeleton from "~/features/company-wall/components/company-wall-details/content/CompanyWallDetailsCharacteristicsSkeleton.vue";
import CompanyWallDetailsPortfolioSkeleton from "~/features/company-wall/components/company-wall-details/content/CompanyWallDetailsPortfolioSkeleton.vue";
import CompanyWallProductsSkeleton from "~/features/company-wall/components/company-wall-details/content/CompanyWallProductsSkeleton.vue";
import CompanyWallQuestionsSkeleton from "~/features/company-wall/components/company-wall-details/content/CompanyWallQuestionsSkeleton.vue";
import IconInfoCardSkeleton from "~/features/company-wall/components/company-wall-details/content/IconInfoCardSkeleton.vue";

const { tr } = useI18nMainSiteCompanyWall();
</script>
